<form [formGroup]="autocompleteForm">
  <mat-form-field [ngStyle]="{ 'width.vw': width }" [ngClass]="formFieldClassName">
    <mat-label> {{inputOnFocus?floatLabelOnFocus:floatLabelOnBlur}} </mat-label>
    <input
      #inputField
      type="text"
      #text
      matInput
      [placeholder]="placeHolder"
      [attr.id]="buildAutocompleteId('fld-input')"
      (focus)="inputOnFocus=true;setIsonFocus()"
      (blur)="inputOnFocus=false;setIsonFocus()"
      formControlName="textFormControl"
      [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete" [panelWidth]="'fit-content'" [ngClass]="autocompleteClassName" hideSingleSelectionIndicator>
        @for (option of filteredOptions(); track option) {
          <mat-option (click)="optionsSelected()" [ngStyle]="{ 'max-width.vw': widthForOptions }" [value]="option.DisplayTextForSelectedValue">
            <div class="pre-line" [innerHTML]="option.SuggestionText"></div>
          </mat-option>
        }
      </mat-autocomplete>
      @if (!inputOnFocus && autocompleteForm.controls.textFormControl.hasError('required')) {
        <mat-error matTooltipClass="tooltip-style" matTooltipPosition="below" appMatTooltip="{{requiredErrorMessage}}"
          class="m-t-m text-overflow-ellipsis" [ngClass]="errorFieldClassName"
          >
          {{requiredErrorMessage}}
        </mat-error>
      }
      @if (autocompleteForm.controls.textFormControl.hasError('pattern') &&
        !autocompleteForm.controls.textFormControl.hasError('required')) {
        <mat-error matTooltipClass="tooltip-style" matTooltipPosition="below" appMatTooltip="{{inputValidationErrorMessage}}"
          class="m-l--15 text-overflow-ellipsis" [ngClass]="errorFieldClassName"
          >
          {{inputValidationErrorMessage}}
        </mat-error>
      }
      @if (text?.value?.length<minType && inputOnFocus) {
        <div
          [attr.id]="buildAutocompleteId('msg-min-type')"
          >
          <p
            class="text-overflow-ellipsis warning-text min-type-warning"
            matTooltipClass="tooltip-style"
            matTooltipPosition="below"
            appMatTooltip="{{minTypeWarningMessage}}"
            >
            <span class="info-icon cursor">!</span>
            Enter at least {{minType}} characters to search
          </p>
        </div>
      }
      @if (text?.value?.length>=minType && text?.value?.length>=1 && inputOnFocus && filteredOptionsLength === 0) {
        <div [attr.id]="buildAutocompleteId('msg-no-results')"
          >
          <p matTooltipClass="tooltip-style"
            matTooltipPosition="below"
            appMatTooltip="{{noResultsWarningMessage}}"
            class="warning-text text-overflow-ellipsis no-results-warning" [ngClass]="warningFieldClassName">
            <span class="info-icon cursor">!</span>
            {{noResultsWarningMessage}}
          </p>
        </div>
      }
    </mat-form-field>
  </form>